<template>
    <div :key="`grid-${index}`" :ref="(el) => setGridRef(el, index)" class="grid" :class="{ invis: !service }">
        <ServiceItem v-if="service" :service="service" />
    </div>
</template>

<script setup lang="ts">
    import type { IService } from "@/data/model/Service";
    import { type ComponentPublicInstance } from "vue";

    import ServiceItem from "@/app/components/service/ServiceItem.vue";

    defineProps<{
        service: IService | null;
        index: number;
        setGridRef: (el: Element | ComponentPublicInstance | null, index: number) => void;
    }>();
</script>

<style lang="scss"></style>
